export { MenuItemIcon } from './MenuItemIcon';
